'use client';

import { useContext } from 'react';

import { Context } from '../context';

import type { PopperContext } from '../context';

export const usePopperContext = (): PopperContext => useContext<PopperContext>( Context );
